import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-4 lg:gap-6 -mt-10 -mb-4" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 2 }

import { 
		useI18n
	} from 'vue-i18n'

	// store
	import { 
		localesStore as _localesStore
	} from '@/store/locales'

	// vue
	import {
		computed
	} from 'vue'
	
	
// name the component
	const __default__ = { name: 'AreaDetails' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		contact: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	// languages
	const props = __props

	const localesStore = _localesStore()

	const {t} = useI18n()

	const areas = computed(() => {
		const numEmail = props?.contact?.portalData?.portal_emails.length
		const numPhone = props?.contact?.portalData?.portal_phone_numbers.length
		const numAreas = props?.contact?.portalData?.portal_areas.length
		const numToAdd = numEmail + numPhone + 2 - numAreas
		let _areas = [...props?.contact?.portalData?.portal_areas || []]
		for(let i = 0 ; i < numToAdd ; i++) {
			_areas.push({})
		}
		return _areas
	})
	

return (_ctx: any,_cache: any) => {
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tw_table, {
      class: "hidden lg:block",
      placeholder: _unref(t)('placeholders.noAreas'),
      data: areas.value,
      loading: __props.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(localesStore).getLabel('17')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row['contact__are__AREAS_COUNTRIES__areaCountryID::area_display']), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(localesStore).getLabel('292')
        }, {
          default: _withCtx(({row}) => [
            (row['contact__AREAS__contactID::primary'])
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5 text-black"
                }))
              : (row['contact__AREAS__contactID::primary'] === '')
                ? (_openBlock(), _createBlock(_component_MinusIconMini, {
                    key: 1,
                    class: "h-5 w-5 text-gray-300"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, "   "))
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"]),
    _createVNode(_component_tw_table, {
      class: "lg:hidden block",
      placeholder: _unref(t)('placeholders.noAreas'),
      data: __props.contact?.portalData?.portal_areas,
      loading: __props.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(localesStore).getLabel('17')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row['contact__are__AREAS_COUNTRIES__areaCountryID::area_display']), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(localesStore).getLabel('292')
        }, {
          default: _withCtx(({row}) => [
            (row['contact__AREAS__contactID::primary'])
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5 text-black"
                }))
              : (row['contact__AREAS__contactID::primary'] === '')
                ? (_openBlock(), _createBlock(_component_MinusIconMini, {
                    key: 1,
                    class: "h-5 w-5 text-gray-300"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, "   "))
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"])
  ]))
}
}

})